<div
  class="text-warning bold"
  [innerHTML]="'SB_Capacity_Warning_Title' | translate"
></div>

<ol>
  @for (exceed of exceedCapacityByChangeRequests; track exceed) {
    <li class="text-info">
      <p
      [innerHTML]="
        'SB_Capacity_Warning_Message'
          | translate : getMessagesTranslationParams(exceed)
      "
      ></p>
      <ul>
        @for (item of exceed.relatedChangeRequests; track item) {
          <li class="cr-detail">
            <span
          [innerHTML]="
            'SB_Capacity_Warning_Detail'
              | translate : getDetailTranslationParams(item)
          "
              ></span
              ><span
              class="glyphicon glyphicon-info-sign"
              [ngbTooltip]="reasons"
              placement="end"
              triggers="click"
            ></span>
            <ng-template #reasons>
              <div class="reasons">
                @if (item.reason) {
                  <em>Reason(Request)</em>
                }
                <div>{{ item.reason }}</div>
                @if (item.responseReason) {
                  <em>Reason(Response)</em>
                }
                <div>{{ item.responseReason }}</div>
              </div>
            </ng-template>
          </li>
        }
      </ul>
    </li>
  }
</ol>

<p class="text-warning">{{ 'SB_Capacity_Warning_Check' | translate }}</p>
